'use strict'

window.$ = window.jQuery = require('jquery');
window.fancybox = require('@fancyapps/fancybox');
window.Swiper = require('swiper/swiper-bundle');

import product from './product/product.js';
import search from "./search/search.js";
import cart from "./cart/cart.js";
import profile from "./profile/profile.js";

const headerElement = document.getElementById('header');

const buttonDisabled = [...document.querySelectorAll('.button.disabled')]; 

const scrollUpdate = _ => {
    if((window.scrollY > 10)) {
        if(!headerElement.classList.contains('scroll'))
            headerElement.classList.add('scroll');
    } else {
        headerElement.classList.remove('scroll');
    }
}

const searchUrlParam = value => {
	let url = new URLSearchParams(window.location.search.slice(1));
	return url.get(value);
}

const setDisabledBehaviour = button => { 
	button.addEventListener('click', e => {
		if(e.currentTarget.classList.contains('disabled'))
			e.preventDefault();
	});
}

document.addEventListener('scroll', function(){
    scrollUpdate();
});

document.addEventListener('DOMContentLoaded', function(){
    product.detail();
    product.list();
	search();
	cart();
	profile();
	
	buttonDisabled.forEach(setDisabledBehaviour);

	$("#selectionbutton").click(function(){
		$("#selection").toggle();
		if($("#selection").is(":visible"))
		{
			$('.filtericon').removeClass('fa-chevron-down');
			$('.filtericon').addClass('fa-chevron-up');
		}
		else
		{
			$('.filtericon').removeClass('fa-chevron-up');
			$('.filtericon').addClass('fa-chevron-down');
		}
	});

	if(searchUrlParam('page') > 1)
	{
		$('#header').addClass('next-page');
		$('#intro').css('min-height', '90px').css('padding-top', '0px');
		$('#intro').find('.wrapper').hide();
	}
	else
	{
		$('#header').removeClass('next-page');
	}
});
